interface DynamicPricingRequest {
  EndDate: string
  ProductAttributeValueIds: number[]
  ProductId: number
  StartDate: string
}

function instanceOfDynamicPricingRequest(request: any): request is DynamicPricingRequest {
  const propertiesExist =
    'EndDate' in request && 'ProductAttributeValueIds' in request && 'ProductId' in request && 'StartDate' in request
  if (propertiesExist) {
    return !!Date.parse(request['EndDate']) && !!Date.parse(request['StartDate']) && !!parseInt(request['ProductId'])
  } else {
    return false
  }
}

export { DynamicPricingRequest, instanceOfDynamicPricingRequest }
